import { useEffect, useState } from 'react'
import { db, type Expense } from '../lib/db'
import { getCurrentOdometer } from '../lib/sync'
import { calcOverview, calcCategoryRows, calcMonthRows } from '../lib/calculations'
import StatsGrid from './overview/StatsGrid'
import { CATEGORIES } from './record/constants'

export default function OverviewPage() {
  const [expenses, setExpenses] = useState<Expense[]>([])
  const [currentOdo, setCurrentOdo] = useState(0)
  const [statsStart, setStatsStart] = useState<string | null>(null)

  useEffect(() => {
    db.expenses.filter(e => e.deleted_at === null).toArray().then(setExpenses)
    getCurrentOdometer().then(setCurrentOdo)
    db.settings.get('singleton').then(s => setStatsStart(s?.stats_start_month ?? null))
  }, [])

  const stats    = calcOverview(expenses, currentOdo)
  const catRows  = calcCategoryRows(expenses, statsStart)
  const monthRows = calcMonthRows(expenses, statsStart)

  return (
    <div className="overview-page">
      <header className="page-header">
        <div className="page-header-left">
          <h1 className="page-header-title">總覽</h1>
          {statsStart && <p className="page-header-sub">統計自 {statsStart.slice(0, 7)}</p>}
        </div>
      </header>

      <StatsGrid stats={stats} />

      {/* 類別表 */}
      <section>
        <h3 className="section-title">各類別合計</h3>
        <div className="cat-table">
          <div className="cat-row cat-header">
            <span>類別</span><span>金額</span><span>筆數</span><span>占比</span>
            {statsStart && <span>統計期</span>}
          </div>
          {catRows.map(r => (
            <div key={r.category} className="cat-row">
              <span>{r.category}</span>
              <span>NT${r.total.toLocaleString()}</span>
              <span>{r.count}</span>
              <span>{(r.ratio * 100).toFixed(1)}%</span>
              {statsStart && <span>NT${r.periodTotal.toLocaleString()}</span>}
            </div>
          ))}
        </div>
      </section>

      {/* 每月表 */}
      {monthRows.length > 0 && (
        <section>
          <h3 className="section-title">每月花費</h3>
          <div className="month-table-wrap">
            <table className="month-table">
              <thead>
                <tr>
                  <th>月份</th>
                  {CATEGORIES.map(c => <th key={c}>{c}</th>)}
                  <th>合計</th>
                </tr>
              </thead>
              <tbody>
                {monthRows.map(row => (
                  <tr key={row.month}>
                    <td>{row.month}</td>
                    {CATEGORIES.map(c => (
                      <td key={c}>{row.byCategory[c] ? row.byCategory[c].toLocaleString() : '—'}</td>
                    ))}
                    <td><strong>{row.rowTotal.toLocaleString()}</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}

      {!statsStart && (
        <p className="placeholder">在「更多 → 設定」裡設定統計起始月，就能看到每月明細與統計期間欄位。</p>
      )}
    </div>
  )
}
